// src/components/compliance/Chips.tsx
//
// Purely visual chips for the Compliance domain. Kept in one file so
// tests can rely on stable data-testid attributes.

import type {
  ComplianceApprovalStatus,
  ComplianceDocumentStatus,
  ComplianceEnforcementMode,
  EligibilitySeverity,
} from '../../types/api';
import {
  APPROVAL_STATUS_CHIP,
  APPROVAL_STATUS_LABEL,
  DOC_STATUS_CHIP,
  DOC_STATUS_LABEL,
  ENFORCEMENT_MODE_CHIP,
  ENFORCEMENT_MODE_LABEL,
  SEVERITY_CHIP,
  SEVERITY_LABEL,
} from './complianceDisplay';

const BASE = 'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium';

export function EnforcementModeChip({ mode }: { mode: ComplianceEnforcementMode }) {
  return (
    <span
      className={`${BASE} ${ENFORCEMENT_MODE_CHIP[mode]}`}
      data-testid={`compliance-enforcement-chip-${mode}`}
    >
      {ENFORCEMENT_MODE_LABEL[mode]}
    </span>
  );
}

export function EligibilityChip({ severity }: { severity: EligibilitySeverity }) {
  return (
    <span
      className={`${BASE} ${SEVERITY_CHIP[severity]}`}
      data-testid={`compliance-severity-chip-${severity}`}
    >
      {SEVERITY_LABEL[severity]}
    </span>
  );
}

export function DocumentStatusChip({ status }: { status: ComplianceDocumentStatus }) {
  return (
    <span
      className={`${BASE} ${DOC_STATUS_CHIP[status]}`}
      data-testid={`compliance-doc-chip-${status}`}
    >
      {DOC_STATUS_LABEL[status]}
    </span>
  );
}

export function ApprovalStatusChip({ status }: { status: ComplianceApprovalStatus }) {
  return (
    <span
      className={`${BASE} ${APPROVAL_STATUS_CHIP[status]}`}
      data-testid={`compliance-approval-chip-${status}`}
    >
      {APPROVAL_STATUS_LABEL[status]}
    </span>
  );
}
